export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/mugs.14c045c.svg";